import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MessageState {
  message: string | null;
  color: string;
}

const initialState: MessageState = {
  message: null,
  color: '#d32f2f', // Default error color (red)
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setErrorMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
      state.color = '#d32f2f'; // Red for errors
    },
    setSuccessMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
      state.color = '#2e7d32'; // Green for success
    },
    setMessage: (state, action: PayloadAction<{ message: string; color: string }>) => {
      state.message = action.payload.message;
      state.color = action.payload.color;
    },
    clearMessage: (state) => {
      state.message = null;
      state.color = '#d32f2f';
    },
  },
});

export const { setErrorMessage, setSuccessMessage, setMessage, clearMessage } = messageSlice.actions;
export default messageSlice.reducer;
